var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 100,
    width: 100,
    viewBox: "0 0 56 226",
    style: {
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "  \n   \n    .fil0 {fill:#000000}\n   \n  "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M28 0c15 0 28 12 28 28 0 15-13 28-28 28-16 0-28-13-28-28 0-16 12-28 28-28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M28 85c15 0 28 13 28 28 0 16-13 28-28 28-16 0-28-12-28-28 0-15 12-28 28-28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M28 171c15 0 28 12 28 27 0 16-13 28-28 28-16 0-28-12-28-28 0-15 12-27 28-27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalDots);
export default __webpack_public_path__ + "static/media/verticalDots.1a9759b676708a809e9fa6fc7c974a27.svg";
export { ForwardRef as ReactComponent };